export default {
	sec_10: {
		title: {
			one: 'Receive ',
			two: 'Deposit',
		},
		desc: {
			one: 'Receive deposits conveniently with JP WORLD Pay',
		},
		btn: {
			one: 'Send Asset',
			two: 'Download App',
		},
	},
	sec_11: {
		title: {
			one: 'The most convenient deposit',
		},
		desc: {
			one: "Just send it to the other person's email and you're done.",
		},
	},
	sec_04: {
		title: 'What recipients see',
		cards: {
			one: {
				title: {
					one: 'Transfers between JP WORLD Pay',
					two: 'and JP WORLD Pay',
				},
				description: {
					one: 'When transferring money from',
					two: 'JP WORLD Pay to JP WORLD Pay, ',
					three: 'the account number used will be displayed.',
				},
			},
			two: {
				title: {
					one: 'Deposit from outside',
					two: 'using JP WORLD Pay',
				},
				description: {
					one: 'When depositing funds from outside',
					two: 'using JP WORLD Pay, the wallet',
					three: 'address used will be exposed.',
				},
			},
		},
	},
};
